import React from "react";
import {
  SEO,
  Image,
  MarkdownContent,
  BasicCarousel,
} from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";
import "../style/legacy.css";

export default class LegacyPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.deananthonylb.com/legacy/"}
        />
        <Grid
          className={"custom-page-legacy custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"cbmjkndadfkpehai full-width"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"fdhpbciakgalebfb"}
              style={{ padding: 16 }}
              width={16}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ maxHeight: "600px", minHeight: "600px" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "63668c70-c590-40f5-8dc0-65ba0ce92410",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.30)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "f8799158-72fc-48d8-93e7-f1ed00b8d481",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"pdlmcpimieiieflg"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"nghehnddhmjpekmb"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__dedf12cf-aa5c-4f77-ae5b-194150445158"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/Legacy_1.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7479.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7071_SezwJtq.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7077.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7069_Ih3NQRd.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"cdknolknicjieekd"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "38e9a38a-c389-46dc-81af-9a6524b60b29",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"ehbgfabgnkhheaoa"}
            style={{ padding: "40px", background: "#EBE6E0" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
          >
            <Grid.Column
              className={"ddlbbidaiddoefgp"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "33967cc3-bc36-425d-a5ba-8885225321a4",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"lfahplmcephmeflo"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__cb77b836-cff9-40e1-9907-abdb2b1cd084"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/Legacy_2.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/IMG_7463.JPG"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464213170_8943294709027639_3338444426195755847_n_oXPOFii.jpg"
                        }
                      />,
                      <Image
                        key={"4"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464740361_8994218303935279_3562233303543948351_n.jpg"
                        }
                      />,
                      <Image
                        key={"5"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464026301_8943276059029504_6839672513960517365_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"6"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464009965_8941401812550262_2103340149097025595_n.jpg"
                        }
                      />,
                      <Image
                        key={"7"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464066116_8941401542550289_3902015313320248931_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"8"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/463073961_8905707892786321_5915912829435596785_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"9"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/462850527_8907900075900436_7785847929992577787_n_1.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"kmheegnanppkepbh"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"oflbfadnodgoekid"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__e9b91998-4125-4a7b-bb01-1da1e01069c4"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/IMG_7860.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/Babrer.png"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Grid3_1.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"albneajgooioehfp"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "4369f0f3-eccd-4b0b-91fb-a19da1cc33f8",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"dikbfhhppcocempk"}
            style={{ padding: "40px", background: "#EBE6E0" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
          >
            <Grid.Column
              className={"mobgompflonheooh"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "c0d9d701-4364-42a8-bcbd-821ec7e95dda",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"gkmphajlampbefpa"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__5c0c6ae7-fb2a-4107-b4f7-680dd1f021e3"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_4_.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7432.JPG"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7393.JPG"
                        }
                      />,
                      <Image
                        key={"4"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/512719317_24300381946220951_2508138692520552572_n.jpg"
                        }
                      />,
                      <Image
                        key={"5"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7420.JPG"
                        }
                      />,
                      <Image
                        key={"6"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/dean_cards_FsmsILN.jpg"
                        }
                      />,
                      <Image
                        key={"7"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/513967778_24329825196609959_8474959298113776066_n.jpg"
                        }
                      />,
                      <Image
                        key={"8"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464147210_8949850908372019_389067697110411093_n.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fdbjegnloaciepie"}
            style={{ padding: "40px" }}
            columns={2}
          >
            <Grid.Column className={"nliihillmbbpenmm"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__89bcf12c-367a-474a-9fc4-cbcd9393af9c"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/Grid5.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/o-10_VmUz50X.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7116.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7128.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"dohjalbffnnfehci"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "d7190550-d31f-4db1-ac88-5b394b533b33",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"oieifbocbmpgeoog"}
            style={{ padding: "40px", background: "#EBE6E0" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
          >
            <Grid.Column
              className={"ohmkafodfgloegpn"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "01d80c21-77fc-4af3-8d3a-c0d3cc08557f",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"kmpnphikaajaeake"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__91e3c5d9-1444-4ea2-8fa9-28cd22e7a498"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_6_duTMgun.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/DA_0039.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/DA_0026.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/dean-stations-dean.png"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7453.JPG"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fjgomoblfheheica"}
            style={{ padding: "40px" }}
            columns={2}
          >
            <Grid.Column className={"djbfdppcdalheheo"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__92bde1a1-4185-4244-98ec-236bdb49155f"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/Legacy_8.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/SD_LBX_0070.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/57a65ccc-6f83-4275-aa8e-3bc6b2ec2b05/27A0877A-8DF8-44FF-B292-41F31E99029C.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/SD_LBX_0079.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/2023-01-04-6.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"cnbfpjgediojebco"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "5b9272b7-5665-4279-83b5-9f300b6cac3e",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"igeikagpecffejce"}
            style={{ padding: "40px", background: "#EBE6E0" }}
            reversed={"mobile"}
            columns={2}
          >
            <Grid.Column className={"kidaopbfjpbheooc"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "d43495e9-014a-460a-b310-150ea945679f",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column className={"joghnncghfnbecdl"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", objectFit: "contain" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "9fbafee0-5163-4934-95a0-1da11afad8cd",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"dmlmcnbmmffoeihn"}
            style={{ padding: "30px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"ppcoifhfkjdnehin"}
              style={{ padding: "25px", background: "#B9A893" }}
              width={8}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "228401b9-db0e-45ed-a9d6-c8ed940e89b8",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"hnhlkbebmaigepoa full-width"}
            style={{ padding: "0px" }}
            columns={1}
          >
            <Grid.Column
              className={"hcjcjklndhhjekjl"}
              style={{ padding: "0px" }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{
                    maxHeight: "500px",
                    minHeight: "500px",
                    backgroundSize: "cover",
                  }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "12c5af9e-97a0-4382-8bf8-5c3979412b77",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.62)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "6b8ddf95-87fb-40a5-a63e-183d66f44a57",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 35845 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
